import toelatingenApi from "../../../api/e-loket/toelatingenApi";
import FilesHelper from "../../common/FilesHelper";
import { formatFilesForSave } from "../../../components/common/FilesHelperUtil";
import * as messages from "../../../constants/ToastrConstants";
import { showToastrError, showToastrWarning, showToastrSuccess } from "../../../util/toastr";
import mergeDeep from "../../../util/mergeDeep";
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";

import assign from 'object-assign';

export default class ToelatingenPageHelper {

	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;

		const params = context.props.match.params;
		const modelId = params.modelId;
		const disabled = params.isDisabled || false;

		const returnUrl = decodeURIComponent(context.props.match.params.returnUrl);

		context.filesHelper = new FilesHelper(context, modelId);

		ajaxActions.started();
		if (modelId) {
			toelatingenApi.get(modelId)
				.then((response) => {
					ajaxActions.ended();
					this.processModel(response);
				})
				.catch((ex) => {
					ajaxActions.failed();
					context.props.throwException(ex);
				});
		}

		context.setState({
			modelId,
			returnUrl,
			disabled
		});
	}

	save() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;

		context.filesHelper.commitSession();
		//todo rework documentsModel server side to avoid this
		let fileBaseUrl = this.context.filesHelper.getBaseFileLocation();
		let documentsForSave = formatFilesForSave(context.state.fileComponents, fileBaseUrl);

		let errors = null;
		let model = null;

		let modelToSave = this.context.state.model;

		ajaxActions.started();
		return toelatingenApi.save(modelToSave, documentsForSave).then((response) => {
			ajaxActions.ended();

			if (response.statusText === "OK" && !response.data.hasValidationErrors) {
				if (Object.keys(response.data.validationResults).length !== 0) {
					model = assign({}, response.data.item);
					errors = assign({}, response.data.validationResults);
					showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS_SAVED, true);
				}
				else {
					model = assign({}, response.data.item, {});
					errors = {};
				}
				context.setState({
					hasUnsavedChanges: false,
					scrollToTop: true
				});

				showToastrSuccess(messages.MESSAGE_SAVED, true);
			} else {
				errors = assign({}, response.data.validationResults);
				model = assign({}, response.data.item, {});
				showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
			}

			context.props.validatieStatussenLoaded(response.data.item.validatiestatusses);

			model.toelatingen = model.toelatingen.map(t => {
				t.toelatingOK = t.toelatingOK === null ? "" : t.toelatingOK;
				return t;
			});

			this.context.setState({
				errors,
				validationMessageType: response.data.hasValidationErrors ? ValidationMessageTypes.ERROR : ValidationMessageTypes.WARNING,
				model,
				shouldScrollToFirstError: true
			});
		})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	processModel(response) {
		const context = this.context;
		let model = response.data;
		let tochtId = model.id;
		context.props.validatieStatussenLoaded(model.validatiestatusses);

		model.toelatingen = model.toelatingen.map(t => {
			t.toelatingOK = t.toelatingOK === null ? "" : t.toelatingOK;
			return t;
		});

		context.setState({
			model,
			tochtId
		});

		context.props.loadLayout(model.naam, tochtId, model.validatiestatusses, null,  model.svlDossierId);
	}

	change(event, toelatingId) {
		const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
		const property = event.target.name.startsWith("toelatingOK") ? "toelatingOK" : event.target.name;

		let model = mergeDeep({}, this.context.state.model);
		const models = model.toelatingen;
		let modelToUpdate = models.find(m => m.id === toelatingId);
		modelToUpdate[property] = value;

		model.toelatingen = [...(models.filter(m => m.id !== toelatingId)), modelToUpdate];
		this.context.setState({
			model: model,
			hasUnsavedChanges: true
		});
	}

	getErrorForProperty(propertyName, toelatingId) {
		const errors = this.context.state.errors && this.context.state.errors.toelatingen && this.context.state.errors.toelatingen[toelatingId] ? this.context.state.errors.toelatingen[toelatingId] : null;
		return errors ? errors[propertyName] : null;
	}
}
